export enum RouteSlug {
  SCRATCH_CARD = 'zdrapka',
  BANK = 'bank',
  END_PAGE = 'koniec',
  NOT_FOUND = 'not-found',
}
